import React from 'react';
import { injectIntl } from 'react-intl';
import { Input, Tooltip } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import './styles.css';

type Props = {
  intl: {
    messages: [];
  };
};

type StateProps = {
  form: any,
};

type DispatchProps = {
  setFormSettings: Function,
};

const SchedulingTab: React.FC<Props & DispatchProps & StateProps> = ({
  intl,
  form,
  setFormSettings,
}) => {

  const CustomTooltip = ({ content }) => (
    <Tooltip title={content} placement="right-start" arrow>
      <InfoOutlined style={{ marginLeft: '5px' }} fontSize="small" />
    </Tooltip>
  );

  return (
    <>
      <div className="cf-tab-container">
        <div className="cf-simple-fields">
          <div style={{ display: 'flex' }}>
            <div style={{ width: '100%' }}>
              <div className="cf-field">
                <p>{intl.messages['forms.new.scheduling.limit']}</p>
                <div className="cf-field-input">
                  <Input
                    className="content-input"
                    onChange={event => {
                      setFormSettings({ ...form, schedulingLimit: event.target.value });
                    }}
                    value={form.schedulingLimit}
                    disableUnderline
                    placeholder={intl.messages['forms.new.placeholders.scoreLimit']}
                    type='number'
                    inputProps={{ min: 1, max: 100 }}
                  />
                </div>
              </div>
              <div className="cf-field">
                <p>{intl.messages['forms.new.scheduling.high']}</p>
                <div className="cf-field-input">
                  <Input
                    className="content-input"
                    onChange={event => {
                      setFormSettings({ ...form, highScoreScheduling: event.target.value });
                    }}
                    value={form.highScoreScheduling}
                    disableUnderline
                    placeholder={intl.messages['forms.new.placeholders.highScoreScheduling']}
                    type='number'
                    inputProps={{ min: 1, max: 1000 }}
                  />
                </div>
              </div>
              <div className="cf-field">
                <p>{intl.messages['forms.new.scheduling.low']}</p>
                <div className="cf-field-input">
                  <Input
                    className="content-input"
                    onChange={event => {
                      setFormSettings({ ...form, lowScoreScheduling: event.target.value });
                    }}
                    value={form.lowScoreScheduling}
                    disableUnderline
                    placeholder={intl.messages['forms.new.placeholders.lowScoreScheduling']}
                    type='number'
                    inputProps={{ min: 1, max: 1000 }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default injectIntl(SchedulingTab);
